import React, { useEffect } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  success: "success" | "error" | null;
}

const MessageModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  success,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling on body
    } else {
      document.body.style.overflow = "auto"; // Re-enable scrolling on body
    }

    // Cleanup function to reset on component unmount or when modalOpen changes
    return () => {
      document.body.style.overflow = "auto"; // Ensure scrolling is re-enabled
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-custom-atrament bg-opacity-50 flex items-center justify-center z-50">
      {/* Modal container */}
      <div className="bg-custom-white rounded-lg max-w-sm w-full p-6 relative shadow-lg">
        {/* Header with icon and title */}
        <div className="flex items-center mb-4 flex-col">
          {success === "success" && (
            <FaCheckCircle className="w-10 h-10 mb-8 mt-4 text-custom-green" />
          )}
          {success === "error" && (
            <IoMdCloseCircle className="w-10 h-10 mb-8 mt-4 text-custom-orange" />
          )}

          <h3 className="ml-2 text-xl font-semibold">{title}</h3>
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-custom-atrament text-3xl hover:text-custom-salmon pr-2"
            aria-label="Close modal"
          ></button>
        </div>
        {/* Message */}
        <p className="mb-8 text-center text-custom-atrament-gray">{message}</p>
        {/* Action button */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-custom-atrament text-custom-white px-4 py-2 rounded hover:bg-custom-salmon"
          >
            Zavrieť
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
